function loadFlippScript(): Promise<void> {
  return new Promise((resolve) => {
    if (window.Flipp) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://aq.flippenterprise.net/6751/iframe.js';
    script.onload = () => resolve();
    document.head.appendChild(script);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const flippContainer = document.querySelector<HTMLElement>('#flipp-container');

  if (!flippContainer) {
    return;
  }

  loadFlippScript().then(() => {
    let storefront = new window.Flipp!.Storefront({
      accessToken: '00bbea0dfbe6a1efb474e62cc0327cbd',
      merchantId: '6751',
      merchantNameIdentifier: 'millbankhardware',
      locale: 'en-CA',
      autoStore: true,
      autoLocate: true,
      autoFlyer: true,
      hide: Number(document.body.dataset.cid) ? 'hidden' : 'visible',
    });

    storefront.renderStorefront(flippContainer);
  });
});
